import breakpoints from './utils/breakpoints'

import IframeYoutube from './components/IframeYoutube/IframeYoutube'
customElements.define('iframe-youtube', IframeYoutube)

import IframeVimeo from './components/IframeVimeo/IframeVimeo'
customElements.define('iframe-vimeo', IframeVimeo)

import ToggleElement from './utils/ToggleElement.js'
const toggleTriggers = [...document.querySelectorAll('[data-toggle-trigger]')]
for (let trigger of toggleTriggers) {
  new ToggleElement(trigger)
}


import { SearchHelper } from './components/SearchHelper/SearchHelper'
SearchHelper()

import initMenuMobile from './components/Menu/MenuMobile'
import initMegaMenu from './components/Menu/MegaMenu'

initMenuMobile({menuBreakpoint: breakpoints.large})
initMegaMenu({largeWidth: breakpoints.large})


// For animation
document.addEventListener("DOMContentLoaded", () => {
  window.setTimeout( () => document.body.classList.add('ready'), 10)
})
